import React from 'react';
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux';
import PrivateRoute from './components/Auth/PrivateRoute';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import GuestRoute from './components/Auth/GuestRoute';

import Login from './pages/Login';
import Home from './components/Home';
import Users from './components/Users/index';
import Products from './components/Products/index';
import Orders from './components/Orders/index';
import Notification from './components/Notification/index';

import Editor from './components/Help/Editor';
import HelpPage from './components/Help/HelpPage';


export const menuRoutes = [
  {
    to: "/",
    text: "Dashboard",
    exact: true,
    roles: ['admin']
  },
  {
    to: "/users",
    text: "Users",
    roles: ['admin']
  },
  {
    to: "/products",
    text: "Products",
    roles: ['admin']
  },
  {
    to: "/orders",
    text: "Orders",
    roles: ['admin', 'finance']
  },
  {
    to: "/notifications",
    text: "Push Notifications",
    roles: ['admin']
  },
  {
    to: "/help",
    text: "Edit Help",
    roles: ['admin']
  }
]

class PrivateApp extends React.Component {
  state = {  }

  checkRoute = (path) => {
    const menu = menuRoutes.find(m => m.to === path);
    if (!menu) {
      return false
    }

    if (!menu.roles) {
      return true
    }
    
    const firstAllowedMenu = menuRoutes.find(m => { 
      if (!m.roles) {
        return true
      }
      return  m.roles.includes(this.props.userRole)
    });

    const pass = menu.roles.includes(this.props.userRole)
    if (!pass && !firstAllowedMenu) {
      return {
        pass: false,
        redirect: false
      }
    }
    
    return {
      pass: menu.roles.includes(this.props.userRole),
      redirect: firstAllowedMenu.to
    }
  }

  render() {
    return (
      <div>
        <ProtectedRoute exact
          path="/"
          component={Home}
          check={this.checkRoute}
        />
        <ProtectedRoute
          path="/users"
          component={Users}
          check={this.checkRoute}
        />
        <ProtectedRoute
          path="/products"
          component={Products}
          check={this.checkRoute}
        />
        <ProtectedRoute
          path="/orders"
          component={Orders}
          check={this.checkRoute}
        />
        <ProtectedRoute
          path="/notifications"
          component={Notification}
          check={this.checkRoute}
        />
        <ProtectedRoute
          path="/help"
          component={Editor}
          check={this.checkRoute}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({ user: state.user.user, userRole: state.user.role });
const mapDispatchToProps = { };
const ConnectedPrivateApp = connect(mapStateToProps, mapDispatchToProps)(PrivateApp);




const routes = (props) => (
  <Switch>
    <Route
      path="/help-page"
      component={HelpPage}
    />
    <GuestRoute
      path="/login"
      component={Login}
      isGuest={!props.isAuthenticated}
    />
    <PrivateRoute
      path="/"
      component={ConnectedPrivateApp}
      isAuthenticated={props.isAuthenticated}
    />
  </Switch>
);


export default routes;



// WEBPACK FOOTER //
// ./src/routes.js